import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export interface UpdateDestinatarioProps {
  notificacaoJustificativasDestinatarioId: string;
  nome: string;
  email: string;
  telefone: string;
  ativo: boolean;
}

export default function useUpdateDestinatario() {
  return useMutation(
    URL.CONFIGURACAO_NOTIFICACOES.EDITAR_DESTINATARIO("id"),
    async (body: UpdateDestinatarioProps) => {
      const response = await http.put(
        URL.CONFIGURACAO_NOTIFICACOES.EDITAR_DESTINATARIO(body.notificacaoJustificativasDestinatarioId),
        body,
      );
      return response;
    },
  );
}
